import { useEffect, useRef, useState } from 'react';
import { apiRequest, getAccessToken, getRequestData, hideKAlert, setAccessToken, setUserAccess, showKAlert } from '../helpers/helpers';
import KAccess from '../components/KAccess';
import { t } from '../locale';

export const App = () => {
    const [companyId, setCompanyId] = useState<string | null>(null)
    const [email, setEmail] = useState<string>('')
    const [createdAt, setCreatedAt] = useState<string>('')

    const pathSegments = window.location.pathname.split('/')
    const requestId = pathSegments[3]
    const recipient = new URLSearchParams(window.location.search).get('r') === 'creator' ? 'creator' : 'user'
    const [access, setAccess] = useState(true)
    const [pin, setPin] = useState('')

    const didRun = useRef(false);

    useEffect(() => {
        if (didRun.current) return;
        didRun.current = true;

        const run = async () => {
            try {
                const response = await apiRequest(
                    `${process.env.REACT_APP_API_URL}/api/v1/company/request/id`,
                    'POST',
                    { requestId },
                    ''
                );

                if (response?.companyId) {
                    const companyId = response.companyId;
                    setCompanyId(companyId);

                    const data = await getRequestData(companyId, requestId);
                    setEmail(data.email);
                    setCreatedAt(data.createdAt);

                    if (data.email) {
                        const accessToken = await apiRequest(
                            `${process.env.REACT_APP_API_URL}/api/v1/access/get/request`,
                            'POST',
                            {
                                email: data.email,
                                companyId: companyId,
                                requestId: requestId,
                                recipient: recipient
                            },
                            '',
                            getAccessToken()
                        );

                        if (accessToken.variant === 'success') {
                            setAccess(false);
                        } else {
                            setAccessToken(accessToken.accessToken);
                        }
                    }
                }
            } catch (err) {
                console.error('Greška u učitavanju podataka:', err);
            }
        };

        run();
    }, [requestId]);

    async function getFile(requestId: string, createdAt: string, fileType: 'pdf' | 'mp4') {
        if (!companyId) {
            console.error('companyId nije učitan još.')
            return
        }
        const fileName = fileType === 'pdf'
            ? `videoidentifikation-${createdAt.split('T')[0]}.pdf`
            : `video.mp4`
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/report/download/admin/${requestId}/${fileName}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    companyId: companyId,
                    requestId: requestId
                })
            });
            if (!response.ok) {
                throw new Error('Greška prilikom preuzimanja fajla.')
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob)
            if (fileType === 'pdf') {
                window.open(url, '_blank');
            } else {
                const videoWindow = window.open();
                if (videoWindow) {
                    videoWindow.document.write(`
                    <video controls autoplay style="width: 100%; height: 100%;">
                        <source src="${url}" type="video/mp4">
                        Video nije podržan u ovom browseru.
                    </video>
                `)
                }
            }

        } catch (error) {
            console.error(error);
        }
    }

    async function validatePinCode(pinCode: number) {
        const accessToken = getAccessToken()
        !!accessToken &&
            fetch(`${process.env.REACT_APP_API_URL}/api/v1/admin/pincode-validation-user`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'accessToken': accessToken },
                body: JSON.stringify({
                    pinCode: pinCode
                })
            }).then(r => r.json())
                .then(r => {
                    if (!!r.accessToken) {
                        setAccessToken(r.accessToken)
                        setUserAccess(r.userAccess)
                        hideKAlert()
                        setAccess(false)
                    } else {
                        showKAlert('danger', t('invalidPinCode'))
                        setTimeout(() => {
                            hideKAlert()
                        }, 5000);
                    }
                })
    }

    return (
        <>
            <div className="container py-5">
                <div className="card shadow-sm border-0">
                    <div className="card-body">
                        <h3 className="text-primary mb-4">
                            <i className="bi bi-file-earmark-play-fill me-2" /> {t('viewOfFiles')}
                        </h3>

                        <p className="text-muted mb-4">
                            {t('downloadPdfAndVideo')}
                        </p>

                        <div className="d-flex gap-3">
                            <button
                                className="btn btn-outline-primary"
                                onClick={() =>
                                    getFile(requestId, createdAt, 'pdf')
                                }
                            >
                                <i className="bi bi-filetype-pdf me-1" />
                                {t('pdfView')}
                            </button>

                            <button
                                className="btn btn-primary"
                                onClick={() =>
                                    getFile(requestId, createdAt, 'mp4')
                                }
                            >
                                <i className="bi bi-play-circle me-1" />
                                {t('videoView')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {access &&
                <KAccess show={access}
                    pin={pin}
                    onConfirm={(pin: any) => {
                        validatePinCode(pin)
                    }}
                    title={t('pinCodeTitleUser')}
                />
            }
        </>
    )


}

export default App;
